export const scope = "Notifications";
const DEFAULT_PROPS = {
  open: false,
  autoHideDuration: 6000,
  onClose: undefined,
  message: undefined,
};

const NotificationStore = (set, get) => ({
  props: DEFAULT_PROPS,

  setValue: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...get()[scope], [key]: value },
      }),
      false,
      `${scope} : setValue: ${key}`,
    );
  },
});

export default NotificationStore;
